import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllBusinessIncomesCommand} from '@/app/business-income/commands/get-all-business-incomes.command'

const httpClient = new AxiosClient()

export const getAllBusinessIncomesCommand = new GetAllBusinessIncomesCommand(httpClient, store)
